(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const pruneExcluded = (root) => {
        // kill by handle in href
        root.querySelectorAll('a[href*="/products/shipping-protection"]').forEach(a => {
          const card = a.closest('.grid__item, .product-card, li, article') || a.closest('a').parentElement;
          if (card) card.remove();
        });
        // kill by data-handle attr if your card sets it
        root.querySelectorAll('[data-handle="shipping-protection"]').forEach(el => {
          const card = el.closest('.grid__item, .product-card, li, article') || el;
          card.remove();
        });
        // kill by tag or product type hints rendered in card (belt-and-suspenders)
        root.querySelectorAll('[data-product-tags],[data-product-type]').forEach(el => {
          const tags = (el.getAttribute('data-product-tags')||'').toLowerCase();
          const ptype = (el.getAttribute('data-product-type')||'').toLowerCase();
          if (tags.includes('hidden-addon') || ptype.includes('shipping protection')) {
            const card = el.closest('.grid__item, .product-card, li, article') || el;
            card.remove();
          }
        });
      };

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            // prune BEFORE reading innerHTML
            pruneExcluded(html);

            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              // safety: if nothing left, do not inject empty container
              const tmp = document.createElement('div');
              tmp.innerHTML = recommendations.innerHTML.trim();
              pruneExcluded(tmp);
              if (tmp.querySelector('.grid__item, .product-card, li, article')) {
                this.innerHTML = tmp.innerHTML;
                this.classList.add('product-recommendations--loaded');
              }
            }
          })
          .catch(e => { console.error(e); });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
